// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio{display:flex;align-items:center;gap:10px}.radio__input{width:19px;height:19px;margin:0;border:2px solid #8a8099;border-radius:50%;-webkit-appearance:none;appearance:none}.radio__input::after{content:\"\";display:block;border-radius:50%;width:11px;height:11px;margin:2px}.radio__input:hover{cursor:pointer}.radio__input:checked{border:2px solid #fe3c72}.radio__input:checked::after{background:#fe3c72}.radio__label{margin:0;cursor:pointer;user-select:none}", ""]);
// Exports
module.exports = exports;
